function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const commentsContainer = document.querySelector("#comments_container");
	// Hash commento presente nell'URL: carica i commenti subito
	// Altrimenti, osserva il container dei commenti e li carica quando entra in view
	if (window.location.hash.substring(1, 9) === "comment_") {
		import("./comments.js").then((module) => {
			const comments = new module.MpComments();
			comments.loadComments();
		});
	} else {
		const commentsObserver = new IntersectionObserver(
			(items) => {
				if (items[0].isIntersecting) {
					import("./comments.js").then((module) => {
						const comments = new module.MpComments();
						comments.loadComments();
					});
					commentsObserver.disconnect();
				}
			},
			{
				rootMargin: "0px 0px 200px 0px",
			},
		);
		commentsObserver.observe(commentsContainer);
	}
});
